<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="name">Префикс номера договора (4 цифры)</label>
    <input
      type="text"
      class="form-control"
      id="name"
      placeholder="Введите префикс"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'contract-number-prefix-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ContractNumberPrefix.vue?26a2a214